// extracted by mini-css-extract-plugin
module.exports = {"button":"GoBackButton_button__12O4G"};